module.exports = __webpack_public_path__ + "static/media/EnvPromo-Shot23.b0130c2d.jpg";